/* eslint-disable */
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import moment from 'moment';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

export interface IListagem {
  idcaixa: string;
  idconta: string;
  numero: string;
  nome: string;
  dataoperacao: Date;
  historico: string;
  entrada: number;
  saida: number;
  idpareceiro: string;
  idoperacao: string;
  tipo: number;
  datalan: Date;
  // `datalan` é só a data (sem hora) — a hora de verdade vem daqui.
  criadoem: Date;
  logo: string;
  status: boolean;
}

export interface IResultado {
  saldoanterior?: number;
  credito?: number;
  debito?: number;
  saldo?: number;
  valorcheque?: number;
  saldoreal?: number;
}

async function PDFCaixa(
  dados: IListagem[],
  resultado: IResultado,
  conta: string
) {

  function formatarMoeda(valor?: number) {
    return (valor ?? 0).toLocaleString('pt-br', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  // `datalan` é só a data (sem hora) — a hora vem de `criadoem`. Registros
  // muito antigos podem cair em 00:00:00; nesses casos mostra só a data.
  function formatarDataHora(datalan: Date, criadoem?: Date) {
    const data = moment(datalan).format('DD/MM/YYYY');
    if (!criadoem) return data;
    const hora = moment(criadoem);
    return hora.format('HH:mm:ss') === '00:00:00' ? data : `${data} ${hora.format('HH:mm')}`;
  }

  const resultadoSeguro = {
    saldoanterior: resultado?.saldoanterior ?? 0,
    credito: resultado?.credito ?? 0,
    debito: resultado?.debito ?? 0,
    saldo: resultado?.saldo ?? 0,
    valorcheque: resultado?.valorcheque ?? 0,
    saldoreal: resultado?.saldoreal ?? 0,
  };

  const logo = dados?.[0]?.logo ?? '';

  const lancaixa = dados.map((caixa) => {
    return [
      { text: formatarDataHora(caixa.datalan, caixa.criadoem), alignment: 'center', style: 'tableBody' },
      { text: caixa.numero ?? '', alignment: 'left', style: 'tableBody' },
      { text: caixa.nome ?? '', alignment: 'left', style: 'tableBody' },
      { text: caixa.historico ?? '', alignment: 'left', style: 'tableBody' },
      { text: formatarMoeda(caixa.entrada), alignment: 'right', style: 'tableBody' },
      { text: formatarMoeda(caixa.saida), alignment: 'right', style: 'tableBody' },
      { text: caixa.status ? 'X' : '', alignment: 'center', bold: true, fontSize: 9 },
    ];
  });

  async function getBase64ImageFromUrl(url: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous';
      img.onload = function () {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) return reject('Erro canvas');
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      };
      img.onerror = () => reject('Erro imagem');
      img.src = url;
    });
  }

  function gerarLogoPadrao(): string {
    const canvas = document.createElement('canvas');
    canvas.width = 320;
    canvas.height = 90;
    const ctx = canvas.getContext('2d');
    if (!ctx) return '';

    ctx.fillStyle = '#1f2937';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.fillStyle = '#ffffff';
    ctx.font = 'bold 22px Arial';
    ctx.textAlign = 'center';
    ctx.fillText('EMPRESA', canvas.width / 2, 50);

    return canvas.toDataURL('image/png');
  }

  let imageData: string;

  if (logo) {
    const baseUrl = (window as any).env?.REACT_APP_URL_IMGLOG || '';
    try {
      imageData = await getBase64ImageFromUrl(baseUrl + logo);
    } catch {
      imageData = gerarLogoPadrao();
    }
  } else {
    imageData = gerarLogoPadrao();
  }

  const documentDefinition: any = {

    pageMargins: [40, 110, 40, 50],

    header: {
      margin: [40, 20, 40, 0],
      columns: [
        {
          width: 80,
          image: imageData,
          fit: [60, 60],
          alignment: 'left'
        },
        {
          width: '*',
          stack: [
            {
              text: process.env.REACT_APP_URL_EMPRESA || '',
              style: 'tituloEmpresa',
              alignment: 'center'
            },
            {
              text: 'CONCILIAÇÃO BANCÁRIA',
              style: 'tituloRelatorio',
              margin: [0, 6, 0, 0],
              alignment: 'center'
            },
            {
              text: `Conta Bancária: ${conta}`,
              style: 'subtitulo',
              margin: [0, 6, 0, 0],
              alignment: 'center'
            }
          ]
        },
        { width: 80, text: '' }
      ]
    },

    footer: function (currentPage: number, pageCount: number) {
      return {
        margin: [40, 0, 40, 10],
        columns: [
          {
            text: moment().format('DD/MM/YYYY HH:mm'),
            fontSize: 8,
            color: '#6b7280',
            alignment: 'left'
          },
          {
            text: `Página ${currentPage} de ${pageCount}`,
            fontSize: 8,
            color: '#6b7280',
            alignment: 'right'
          }
        ]
      };
    },

    content: [

      {
        canvas: [
          {
            type: 'line',
            x1: 0,
            y1: 0,
            x2: 515,
            y2: 0,
            lineWidth: 1,
            lineColor: '#d1d5db'
          }
        ],
        margin: [0, 0, 0, 20]
      },

      {
        table: {
          widths: [80, 80, 80, 80, 80, 80],
          body: [
            [
              {
                stack: [
                  { text: 'Saldo Anterior', style: 'resumoLabel' },
                  { text: formatarMoeda(resultadoSeguro.saldoanterior), style: 'resumoValor' }
                ],
                alignment: 'right'
              },
              {
                stack: [
                  { text: 'Crédito', style: 'resumoLabel' },
                  { text: formatarMoeda(resultadoSeguro.credito), style: 'resumoValor' }
                ],
                alignment: 'right'
              },
              {
                stack: [
                  { text: 'Débito', style: 'resumoLabel' },
                  { text: formatarMoeda(resultadoSeguro.debito), style: 'resumoValor' }
                ],
                alignment: 'right'
              },
              {
                stack: [
                  { text: 'Saldo', style: 'resumoLabel' },
                  { text: formatarMoeda(resultadoSeguro.saldo), style: 'resumoValor' }
                ],
                alignment: 'right'
              },
              {
                stack: [
                  { text: 'Cheque', style: 'resumoLabel' },
                  { text: formatarMoeda(resultadoSeguro.valorcheque), style: 'resumoValor' }
                ],
                alignment: 'right'
              },
              {
                stack: [
                  { text: 'Saldo Real', style: 'resumoLabel' },
                  { text: formatarMoeda(resultadoSeguro.saldoreal), style: 'resumoValor' }
                ],
                alignment: 'right'
              },
            ]
          ]
        },
        margin: [0, 0, 0, 25]
      },

      {
        table: {
          headerRows: 1,
          widths: [50, 50, 120, 150, 40, 40, 20],
          body: [
            [
              { text: 'Data', style: 'tableHeader', alignment: 'center' },
              { text: 'Número', style: 'tableHeader', alignment: 'center' },
              { text: 'Parceiro', style: 'tableHeader' },
              { text: 'Histórico', style: 'tableHeader' },
              { text: 'Crédito', style: 'tableHeader', alignment: 'right' },
              { text: 'Débito', style: 'tableHeader', alignment: 'right' },
              { text: '', style: 'tableHeader' },
            ],
            ...lancaixa
          ]
        },
        layout: {
          fillColor: function (rowIndex: number) {
            return rowIndex % 2 === 0 ? null : '#f9fafb';
          }
        }
      }

    ],

    styles: {
      tituloEmpresa: {
        fontSize: 16,
        bold: true,
        color: '#1f2937'
      },
      tituloRelatorio: {
        fontSize: 18,
        bold: true,
        color: '#111827'
      },
      subtitulo: {
        fontSize: 11,
        color: '#4b5563'
      },
      resumoLabel: {
        fontSize: 9,
        color: '#6b7280',
        bold: true
      },
      resumoValor: {
        fontSize: 11,
        bold: true,
        color: '#111827'
      },
      tableHeader: {
        fontSize: 8,
        bold: true,
        fillColor: '#f3f4f6',
        color: '#111827'
      },
      tableBody: {
        fontSize: 8,
        color: '#374151'
      }
    }
  };

  pdfMake.createPdf(documentDefinition).open();
}

export default PDFCaixa;